import React from 'react';
import useStyles from './styles';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Typography } from '@material-ui/core';
import JetFontIcon, {JET_FONTICON_ALIASES} from '@src/shared/components/JetFontIcon';
import { PAGE_TYPE } from '../..';
import ManagerTestimonials from './ManagerTestimonialKeys';
import CourierTestimonials from './CourierTestimonialKeys';
import { useTranslation } from 'react-i18next';

export interface Testimonial {
  image: string;
  name: string;
  comment: string;
  starRate: number;
}
const TestimonialContent = (props: any) => {
  const classes = useStyles();
  
  // const testimonials: Array<Testimonial> =
  //   props.pageType === PAGE_TYPE.MANAGER ? ManagerTestimonials : CourierTestimonials;

  const testimonials : Array<Testimonial> = ManagerTestimonials

  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:true
    
  };

  const {t} = useTranslation()

  return (
    <div className={classes.testimonialContent}>
      <Slider {...carouselSettings}>
        {testimonials.map((testimonial: Testimonial, index) => (
          <div className="testimonial-item" key={index}>
            <div className="testimonial-container">
              <div className="testimonial-image">
                <img src={testimonial.image} />
              </div>
              <div className="testimonial-content">
                <Typography
                  variant="body1"
                  className="body_regular testimonial-comment"
                  align="left"
                >
                  {t(testimonial.comment)}
                </Typography>
                <Typography
                  variant="body1"
                  className="body_regular testimonial-name"
                  align="left"
                >
                  <b>-  {t(testimonial.name)}</b>
                </Typography>
                <div className='testimonial-star-holder'>
                    {new Array(5).fill(true).map((_element,index)=> {
                        return <JetFontIcon key={index} iconname={testimonial.starRate < index + 1 ? JET_FONTICON_ALIASES.STAR : JET_FONTICON_ALIASES.STAR_FILLED} size={27} />
                    })}
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TestimonialContent;
